import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5ac31d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loby-list-item-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "table-name" }
const _hoisted_4 = { class: "timer" }
const _hoisted_5 = { class: "round" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "span" }, null, -1))
const _hoisted_7 = ["data-label"]
const _hoisted_8 = ["data-label"]
const _hoisted_9 = ["data-label"]
const _hoisted_10 = ["data-label"]
const _hoisted_11 = ["data-label"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill-w" }, null, -1))
const _hoisted_13 = { class: "map-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_map = _resolveComponent("default-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentCount === -1 ? '' : _ctx.currentCount), 1),
      _createElementVNode("div", _hoisted_5, "局数:" + _toDisplayString(_ctx.mapData.round), 1),
      _hoisted_6,
      _createElementVNode("div", {
        class: "red",
        "data-label": _ctx.mdata.gameType === 1 ? _ctx.t('banker') : _ctx.t('dragon')
      }, _toDisplayString(_ctx.mapData.redCount), 9, _hoisted_7),
      _createElementVNode("div", {
        class: "blue",
        "data-label": _ctx.mdata.gameType === 1 ? _ctx.t('player') : _ctx.t('tiger')
      }, _toDisplayString(_ctx.mapData.blueCount), 9, _hoisted_8),
      _createElementVNode("div", {
        class: "green",
        "data-label": _ctx.t('tie')
      }, _toDisplayString(_ctx.mapData.tieCount), 9, _hoisted_9),
      (_ctx.mdata.gameType === 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "red",
            "data-label": _ctx.t('bankerpairabt')
          }, _toDisplayString(_ctx.mapData.redPairCount), 9, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.mdata.gameType === 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "blue",
            "data-label": _ctx.t('playerpairabt')
          }, _toDisplayString(_ctx.mapData.bluePairCount), 9, _hoisted_11))
        : _createCommentVNode("", true),
      _hoisted_12
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_default_map, {
        class: "map",
        "map-data": _ctx.mdata.result,
        "game-type": _ctx.mdata.gameType,
        onRoadMapData: _ctx.OnMapDataChange
      }, null, 8, ["map-data", "game-type", "onRoadMapData"])
    ])
  ]))
}